import { app } from '../../../../../app';

app.component('companyDirectoryIntegrationManageInstructionsAzure', {
    bindings: {
    },
    templateUrl: require('./directory-integration-instructions-azure.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/instructions-azure/directory-integration-instructions-azure.component.js